import OrderOptimizerOptimizationStatusRequest from "../../../api/raily/order-optimizer/optimization-status/order-optimizer-optimization-status.request";
import OrderOptimizerOptimizationStatusParams from "./order-optimizer-optimization-status-params";

const create = (
  loadParams: OrderOptimizerOptimizationStatusParams,
): OrderOptimizerOptimizationStatusRequest => {
  return {
    optimizationId: loadParams.optimizationId,
  };
};

const orderOptimizerOptimizationStatusParamsFactory = {
  create,
};

export default orderOptimizerOptimizationStatusParamsFactory;
